import { z } from 'zod';

// Trying to silence a CSP error, see https://github.com/colinhacks/zod/issues/4461
// as this seems to be the first entrypoint for Zod, at least the `utils.js` stack lead here
z.config({ jitless: true });

const optionalStringOrNumber = z.union([
  z.string(),
  z.number(),
  z.null(),
]).optional;

const optionalString = z.string().nullable().optional;

export const customContextSchema = z.object({
  env: z.object({
    AI_MODERATED_INTERVIEW_AUDIO_DIAGNOSTICS_ENABLED: z.boolean(),
    AI_MODERATED_INTERVIEW_MP3_START_BUFFER_ENABLED: z.boolean(),
    APP_COMMIT: optionalString(),
    APP_VERSION: optionalString(),
    APPCUES_TRANSCRIPT_FEEDBACK_ID: z.string(),
    APPSIGNAL_ENABLED: z.boolean(),
    APPSIGNAL_FALLBACK: z.boolean(),
    APPSIGNAL_JS_API_KEY: z.string(),
    APPSIGNAL_JS_ERROR_LOG_EXPIRATION_SECONDS: z.number(),
    APPSIGNAL_JS_IGNORE_ENABLED: z.boolean(),
    APPSIGNAL_JS_WINDOW_EVENTS: z.boolean(),
    TELEMETRY_USER: z.object({
      id: optionalStringOrNumber(),
      email: optionalString(),
      name: optionalString(),
      organizationId: optionalStringOrNumber(),
      accountId: optionalStringOrNumber(),
      participantId: optionalStringOrNumber(),
      userId: optionalStringOrNumber(),
    }),
    BILLING_PAGE_BOOK_A_DEMO_URL: z.string(),
    BILLING_PAGE_PAID_SUB_CONTACT_URL: z.string(),
    DEBUG_JAVASCRIPT_ERRORS: z.boolean(),
    DROPBOX_SIGN_CLIENT_ID: z.string(),
    DROPBOX_SIGN_SKIP_DOMAIN_VERIFICATION: z.boolean(),
    DROPBOX_SIGN_LIVE_MODE: z.boolean(),
    GOOGLE_BROWSER_API_KEY: z.string(),
    HUB_CONTACT_LIMIT: z.number(),
    HUB_STRING_INPUT_AUTOCOMPLETE_LIMIT: z.number(),
    CLOUDFLARE_TURNSTILE_CAPTCHA_ENABLED: z.boolean(),
    CLOUDFLARE_TURNSTILE_CAPTCHA_SITE_KEY: z.string(),
    INCENTIVES_SURVEY_URL: optionalString(),
    PAGE_THEMES_ENABLED: z.boolean(),
    PARTICIPANT_AVAILABILITY_PROPOSAL_BUFFER_HOURS: optionalStringOrNumber(),
    PARAGON_CONFIG: z.object({
      project_id: optionalString(),
      jwt: optionalString(),
      api_key: optionalString(),
    }),
    PARTICIPANT_AVAILABILITY_PROPOSAL_MAX_COUNT: optionalStringOrNumber(),
    PARTICIPANT_PROJECT_REFERRAL_INCENTIVE: z.number(),
    PARTICIPANT_QNR_SIGNUP_BUFFER: z.number(),
    POPULATION_SEARCH_LIMIT: z.number(),
    PROJECT_BILLING_ACCOUNT_SPLIT: z.boolean(),
    PROJECT_BUILDER_LOOKBACK_URL: optionalString(),
    PROJECT_RECRUITMENT_MULTIPLIER: z.number(),
    PUBLIC_POPULATION_ID: z.number(),
    RECRUITMENT_SOURCE_REPORTS_URL: optionalString(),
    SITE_BASE_URL: z.string(),
    STRIPE_PUBLIC_KEY: z.string(),
    WORKSPACE_EMAIL_STATS_ENABLED: z.boolean(),
  }),
  location: z.string(),
  request: z.object({
    csrfToken: z.string(),
    csrfParam: z.string(),
  }),
  uiState: z.object({
    sessionsPaginationDefaultSize: z.number(),
    isBulkRedeemIncentivesEnabled: z.boolean(),
    isPqBatchStatusBroadcastingEnabled: z.boolean(),
    isEpTeamChargebeeCustomersEnabled: z.boolean(),
    isPvMailchimpDomainAuthenticationEnabled: z.boolean(),
    isPvCustomQualtricsOauthConfigurationEnabled: z.boolean(),
    isPqInviteRulesReadOperatorsEnabled: z.boolean(),
    isPvrApplicationProcessingJobEnabled: z.boolean(),
    isPvrApplicationStatusPollingEnabled: z.boolean(),
    isPvrMissingVerificationsFlowEnabled: z.boolean(),
    isPvrShowMatchedCharacteristicsOnBrowseEnabled: z.boolean(),
    isPvrRegionalHouseholdIncomeEnabled: z.boolean(),
    isPvrNewUsdHouseholdIncomeEnabled: z.boolean(),
    isRecruitPanelShowNewSignInPageEnabled: z.boolean(),
    isLabsAiModeratedTaskEnabled: z.boolean(),
    isMcpSelfServeEnabled: z.boolean(),
    isRptRecruitmentEnabled: z.boolean(),
    isRxHideAiFeaturesToggleEnabled: z.boolean(),
    isRxMeetingBotWebexEnabled: z.boolean(),
    isRxUserTestingMcpIntegrationEnabled: z.boolean(),
    isPvrOccupationTaxonomyEnabled: z.boolean(),
    isPvrBlockNotificationsInactiveProjectsEnabled: z.boolean(),
    isRxSermoEnabled: z.boolean(),
    isRxWorkspaceParticipantPaginationLimitEnabled: z.boolean(),
    isPcaEnabledForOrg: z.boolean(),
    isProjectCreationChatHubProjectsEnabled: z.boolean(),
    isRxTwoPanelChatModeEnabled: z.boolean(),
  }),
  user: z.object({}),
});
